module.exports = __webpack_public_path__ + "media/images/hero-img-0b5228bdd7095d21fead62245d37e0a6.png";